export default __webpack_public_path__ + "static/media/circle-l-top.c06f99ae.png";